import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Box from 'ui-box';
import HeaderBack from '../../../../components/mobile/HeaderBack';
import { Col, Row, Typography } from 'antd';
import ReactPlayer from 'react-player';
import { ReactComponent as PlayCircleSvg } from '../../../../assets/icons/knowledge-bank/play-circle.svg';
import { ReactComponent as PauseCircleSvg } from '../../../../assets/icons/knowledge-bank/pause-circle.svg';
import { ReactComponent as MuteSvg } from '../../../../assets/icons/knowledge-bank/mute.svg';

const { Title, Paragraph } = Typography;

function MobileAudioDetailScreen() {
  const { t } = useTranslation(['knowledge-bank', 'common']);
  const history = useHistory();

  const [muted, setMuted] = useState(false);
  const [played, setPlayed] = useState(0);
  const [loaded, setLoaded] = useState(0);
  const [playing, setPlaying] = useState(true);
  const [loop, setLoop] = useState(false)
  const [playbackRate, setPlaybackRate] = useState(1.0)
  const [volume, setVolume] = useState(0.8)
  const [duration, setDuration] = useState(0)

  const onBack = () => {
    history.push('/knowledge-bank/detail/audio')
  }

  const handleToggleMuted = () => {
    setMuted(!muted);
  }

  const handlePause = () => {
    setPlaying(false);
  }

  const handlePlay = () => {
    setPlaying(true);
  }

  const handleProgress = state => {
    setPlayed(state.played);
  }

  const handleEnded = () => {
    setPlaying(loop)
  }

  const handleDuration = (duration) => {
    setDuration(duration)
  }

  const pad = (string) => {
    return ('0' + string).slice(-2)
  }

  const formatDuration = (duration) => {
    const date = new Date(duration * 1000)
    const hh = date.getUTCHours()
    const mm = date.getUTCMinutes()
    const ss = pad(date.getUTCSeconds())
    if (hh) {
      return `${hh}:${pad(mm)}:${ss}`
    }
    return `${mm}:${ss}`
  }

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('knowledge-bank:goBack')}
        title={'Audio Track 01'}
      />
      <Paragraph style={styles.paragraph}>
        Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up
      </Paragraph>
      <ReactPlayer
        className='react-player'
        width='100%'
        height='100%'
        url={"https://ftp.icm.edu.pl/packages/mp3/1563/Trance%20And%20Acid%20(DJ%20Vintage%20version%20rmx).mp3"}
        playing={playing}
        controls={false}
        playbackRate={playbackRate}
        volume={volume}
        muted={muted}
        onEnded={handleEnded}
        onProgress={handleProgress}
        onDuration={handleDuration}
      />
      <Box style={styles.box}>
        <Row align="middle" justify="space-between">
          <Col xs={1}>
            <MuteSvg onClick={handleToggleMuted} />
          </Col>
          <Col xs={23}>
            <Row align="middle" justify="center">
              <Title level={4} style={styles.title}>
                Play track 01
              </Title>
            </Row>
          </Col>
        </Row>
        <Row align="middle" justify="space-between">
          <Title level={4} style={styles.time}>
            {formatDuration(duration * played)}
          </Title>
          <Title level={4} style={styles.time}>
            {formatDuration(duration)}
          </Title>
        </Row>
        <Row>
          <progress max={1} value={played} style={{ width: '100%' }}/>
        </Row>
        <Box style={styles.boxFooter}>
          <Row align="middle" justify="center">
            {
              playing
              ? <PauseCircleSvg onClick={handlePause} />
              : <PlayCircleSvg onClick={handlePlay} />
            }
          </Row>
        </Box>
      </Box>
    </>
  );
}

const styles = {
  paragraph: {
    fontWeight: "300", 
    fontSize: "14px", 
    lineHeight: "20px", 
    textAlign: "center", 
    color: "#8C8C8C"
  },
  box: {
    marginTop: 35,
    paddingTop: 25,
    paddingBottom: 25,
    paddingLeft: 10,
    paddingRight: 10,
    border: "1px solid #D9D9D9", 
    boxSizing: "border-box", 
    borderRadius: "10px"
  },
  title: {
    fontWeight: "300", 
    fontSize: "14px", 
    lineHeight: "20px", 
    textAlign: "center", 
    color: "#8C8C8C",
    margin: 0
  },
  time: {
    fontWeight: "300", 
    fontSize: "14px", 
    lineHeight: "16px", 
    textAlign: "center", 
    color: "#8C8C8C"
  },
  boxFooter: {
    marginTop: 50
  }
}

export default MobileAudioDetailScreen;
